// AI Agent — xizmat sahifasi kontenti

const uz = {
    meta: {
        title: "AI Agent yaratish — 24/7 mijozlar bilan ishlaydigan aqlli agent",
        description:
            "AI Agent mijoz bilan 24/7 muloqot qiladi: savolga javob beradi, buyurtma qabul qiladi va CRM'ga yozadi. Telegram, WhatsApp va sayt. Narxi 15 mln so'mdan. Innobek.",
        keywords: [
            "AI Agent",
            "AI agent yaratish",
            "sun'iy intellekt agenti",
            "24/7 mijozlarga xizmat",
            "Telegram AI bot",
            "WhatsApp bot",
            "buyurtma qabul qiluvchi bot",
            "AI agent narxi",
            "Claude API",
            "RAG bilimlar bazasi",
        ],
    },

    hero: {
        eyebrow: "Sun'iy intellekt / AI Agent",
        h1: "AI Agent — mijozlaringiz bilan 24/7 muloqot qiladigan aqlli yordamchi",
        lead:
            "Kechqurun kelgan savolga ertalab javob bersangiz, mijoz allaqachon boshqa joydan sotib olgan bo'ladi. AI Agent darhol javob beradi, narxni aytadi, buyurtmani rasmiylashtiradi va murakkab holatda menejerga uzatadi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Telegram, WhatsApp, Instagram va sayt",
            "O'zbek va rus tilida javob beradi",
            "Ovozli xabarlarni tushunadi",
            "Buyurtmani CRM'ga o'zi yozadi",
            "Bilmasa — o'ylab topmaydi, odamga uzatadi",
        ],
    },

    intro: {
        h: "AI Agent nima va u oddiy chatbotdan nimasi bilan farq qiladi?",
        p: [
            "Oddiy bot tugmalar bo'yicha ishlaydi: mijoz tugmani bosadi, bot tayyor matnni chiqaradi. Savol ro'yxatdan chetga chiqsa, suhbat to'xtaydi. Chatbot bir qadam oldinda — savolni tushunadi va matn bilan javob beradi. AI Agent esa undan ham narida: u javob berish bilan cheklanmay, harakat qiladi.",
            "Farq \"tool use\" deb ataladigan imkoniyatda. Agentga aniq vositalar beriladi: ombor qoldig'ini tekshirish, narx hisoblash, buyurtma yaratish, to'lov havolasini olish, navbatga yozish, yetkazib berish holatini so'rash. Mijoz \"42-o'lchamda bormi, bugun yetkazasizmi?\" deb yozganida agent bazaga murojaat qiladi va real javob beradi — taxmin qilmaydi.",
            "Agentning bilimi RAG orqali quriladi. Sizning narxlar ro'yxatingiz, xizmat shartlari, kafolat qoidalari va ko'p beriladigan savollar vektor bazaga (pgvector yoki Qdrant) yoziladi. Savol kelganda tizim eng mos bo'laklarni topib modelga beradi — shuning uchun agent internetdan tasodifiy ma'lumot olmaydi.",
            "Muhim chegara: agent hamma narsani qila olmaydi va biz uni shunday sozlamaymiz. Pul qaytarish, chegirma berish, shikoyatni hal qilish yoki shartnoma o'zgartirish kabi qarorlar odamga qoladi. Agent bunday holatni tanib, suhbatni menejerga to'liq kontekst bilan uzatadi.",
            "Texnik asos: Claude API yoki OpenAI API, integratsiyalar uchun REST API, ovozli xabarlar uchun Whisper, kanallar uchun Telegram Bot API va WhatsApp Business API. Barcha suhbatlar saqlanadi — keyin ularni tahlil qilib, javob sifatini oshiramiz.",
        ],
    },

    definition: {
        term: "AI Agent nima?",
        text:
            "AI Agent — mijoz bilan tabiiy tilda muloqot qiladigan va suhbat davomida real harakatlarni (qoldiqni tekshirish, buyurtma yaratish, navbatga yozish) bajara oladigan sun'iy intellekt dasturi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Mijoz savollarini yig'ish va tahlil qilish (yozishmalar, qo'ng'iroqlar)",
            "Bilimlar bazasini tuzish: narx, shart, kafolat, FAQ",
            "Agent xarakteri va muloqot ohangini kelishish",
            "Vektor baza sozlash (pgvector yoki Qdrant) va indekslash",
            "Claude API yoki OpenAI API ulash va sozlash",
            "Agent bajaradigan harakatlar ro'yxatini aniqlash va cheklash",
            "Menejerga uzatish qoidalari va chegaralari",
            "Kamida 150 ta real savol bilan sinov va xato tahlili",
            "Kanalga o'rnatish: Telegram, sayt vidjeti yoki WhatsApp",
            "Admin panel: bilimlar bazasini yangilash, suhbatlarni ko'rish",
            "Xodimlar uchun qo'llanma va operator rejimi treningi",
            "Oylik API xarajatining real o'lchovi va prognozi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "AI Agent biznesga nima beradi",
        sub: "Agent menejerni almashtirmaydi. U takroriy ishni oladi va murojaat yo'qolishiga yo'l qo'ymaydi.",
        items: [
            {
                t: "Tungi murojaatlar yo'qolmaydi",
                d: "Onlayn savdoda murojaatlarning sezilarli qismi kechqurun va dam olish kunlari keladi. Ertalabgacha kutgan mijozning bir qismi qaytib kelmaydi. Agent istalgan vaqtda 10–20 soniyada javob beradi va kamida telefon raqamini yig'ib qoladi.",
            },
            {
                t: "Menejer vaqti bo'shaydi",
                d: "\"Narxi qancha?\", \"Ish vaqtingiz?\", \"Yetkazib berasizmi?\" — murojaatlarning 50–70% shunday takroriy savollar. Agent ularni yopadi, menejer esa katta buyurtma va murakkab muzokaraga vaqt ajratadi.",
            },
            {
                t: "Buyurtma suhbat ichida rasmiylashadi",
                d: "Agent katalogdan mahsulot ko'rsatadi, qoldiqni tekshiradi, summani hisoblaydi va to'lov havolasini beradi. Mijozni saytga yuborish shart emas — konversiya aynan shu qadamlarda yo'qoladi. Buyurtma ma'lumoti darhol CRM'ga tushadi, menejer esa tayyor kartochkani ko'radi.",
            },
            {
                t: "Bir vaqtda yuzlab suhbat",
                d: "Aksiya yoki reklama kampaniyasi paytida murojaat oqimi bir necha barobar oshadi. Odam navbatga qo'yadi, agent esa parallel ishlaydi — kutish vaqti o'zgarmaydi.",
            },
            {
                t: "Har javob bir xil sifatda",
                d: "Agent charchamaydi, kayfiyati bo'lmaydi va kafolat shartini esdan chiqarmaydi. Yangi xodimni ikki oy o'qitish o'rniga bilimlar bazasini bir marta to'g'ri tuzasiz. Narx o'zgarsa, uni bitta joyda yangilaysiz — barcha kanalda darhol kuchga kiradi.",
            },
            {
                t: "Mijoz nimani so'rashi ko'rinadi",
                d: "Barcha suhbatlar saqlanadi va turkumlanadi. Bir oydan keyin qaysi savol eng ko'p berilganini, qayerda mijoz ketib qolganini aniq ko'rasiz — bu sayt va narx siyosatini tuzatish uchun tayyor ma'lumot.",
            },
            {
                t: "Kichikdan boshlash mumkin",
                d: "Bitta kanal va bitta vazifadan boshlaymiz. Uch-to'rt haftada agent ishga tushadi va siz real natijani ko'rasiz. Kengaytirish keyin — ishlayotgani tasdiqlanganidan so'ng.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlarga mos",
        h: "Qanaqa bizneslar AI Agent buyurtma qiladi",
        sub: "Kuniga 30 dan ortiq murojaat keladigan va javob tezligi sotuvga ta'sir qiladigan sohalar.",
        items: [
            {
                t: "Internet-do'konlar va marketpleyslar",
                d: "Mahsulot mavjudligi, o'lcham, yetkazib berish muddati va buyurtma holati — agent bazadan tekshirib javob beradi.",
            },
            {
                t: "Klinika va tibbiy markazlar",
                d: "Xizmat narxi, shifokor jadvali va navbatga yozish. Tashxis qo'yish agentga yuklanmaydi — bu qat'iy chegara.",
            },
            {
                t: "Ta'lim markazlari va kurslar",
                d: "Dastur, narx, jadval, sinov darsi va ro'yxatdan o'tkazish. Sotuv sikli qisqa, tez javob konversiyaga to'g'ridan-to'g'ri ta'sir qiladi.",
            },
            {
                t: "Restoran va yetkazib berish",
                d: "Menyu bo'yicha maslahat, buyurtma qabul qilish, manzil aniqlash va tayyorlik vaqtini aytish.",
            },
            {
                t: "Ko'chmas mulk va qurilish",
                d: "Obyektlar, narx, to'lov shartlari va ko'rikka yozish. Agent mijozni saralaydi, menejerga faqat tayyor murojaat yetadi.",
            },
            {
                t: "Xizmat ko'rsatuvchi kompaniyalar",
                d: "Usta chaqirish, hudud va muddatni aniqlash, taxminiy narx hisoblash va arizani to'liq rasmiylashtirish.",
            },
            {
                t: "Turizm va transport",
                d: "Tur paketlari, sana bo'yicha joy mavjudligi, hujjat talablari va bron qilish — agent kalendarni tekshirib javob beradi.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "AI Agent narxi — uchta tarif",
        sub: "Ishlab chiqish narxi bir martalik. Model API'sining oylik xarajati alohida hisoblanadi.",
        note:
            "Narxlar 2026-yil uchun, yakuniy hisob bepul konsultatsiyadan keyin tasdiqlanadi. Oylik API xarajati suhbatlar soniga bog'liq: kuniga 50–150 suhbatda taxminan 250 000 – 900 000 so'm, kuniga 300–800 suhbatda 1 000 000 – 3 500 000 so'm atrofida bo'ladi. Bu summa to'g'ridan-to'g'ri provayderga (Anthropic yoki OpenAI) to'lanadi, biz ustiga foiz qo'shmaymiz. WhatsApp Business API'dan foydalanish uchun Meta'ning alohida xabar to'lovi ham bor — uni konsultatsiyada aniq ko'rsatamiz.",
        tiers: [
            {
                name: "Start",
                tagline: "Bitta kanalda javob beradigan agent",
                price: "15 000 000",
                priceNote: "so'mdan",
                term: "3–4 hafta",
                best: "Takroriy savollarni yopish va murojaatlarni yig'ib qolish",
                features: [
                    "Bitta kanal: Telegram yoki sayt vidjeti",
                    "RAG bilimlar bazasi, 300 tagacha sahifa material",
                    "Claude API yoki OpenAI API ulash",
                    "pgvector asosidagi vektor baza",
                    "O'zbek va rus tilida javob berish",
                    "Ariza yig'ish: ism, telefon, so'rov",
                    "Menejerga Telegram orqali bildirishnoma",
                    "Ishonchi past savolni odamga uzatish",
                    "Suhbatlar tarixi va oddiy statistika",
                    "Bilimlar bazasini yangilash uchun admin panel",
                    "3 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Biznes",
                tagline: "Harakat qiladigan, sotuvga ulangan agent",
                price: "38 000 000",
                priceNote: "so'mdan",
                term: "6–9 hafta",
                best: "Buyurtmani suhbat ichida rasmiylashtirish va CRM bilan ishlash",
                featured: true,
                features: [
                    "Start tarifidagi hamma narsa",
                    "Ko'p kanal: Telegram, WhatsApp, Instagram Direct va sayt",
                    "Tool use: qoldiq tekshirish, narx hisoblash, buyurtma yaratish",
                    "CRM yoki 1C bilan ikki tomonlama integratsiya",
                    "To'lov havolasi va buyurtma holatini kuzatish",
                    "Navbatga yozish yoki bron qilish moduli",
                    "Ovozli xabarlarni Whisper orqali tushunish",
                    "Operator rejimi — menejer suhbatga aralasha oladi",
                    "Kengaytirilgan analitika: savol turlari, konversiya, uzatish sababi",
                    "Bilimlar bazasini PDF va Excel fayldan yuklash",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Yopiq kontur va yuqori yuklama",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "3 oydan",
                best: "Ichki tizimlarga ulanish va ma'lumot maxfiyligi talab qilinadigan tashkilotlar",
                features: [
                    "O'z serveringizda ishlaydigan ochiq model (Llama, Qwen)",
                    "ERP, ombor va hujjat bazalariga ulanish",
                    "Bo'limlar bo'yicha alohida rol va bilimlar bazasi",
                    "Qo'ng'iroqlarni qabul qiladigan ovozli agent",
                    "Audit jurnali va shaxsiy ma'lumotlarni maskalash",
                    "Yuklamaga chidamlilik testi va SLA",
                    "Doimiy sifat nazorati va modelni qayta sozlash",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "AI Agent qanday quriladi",
        sub: "Beshta bosqich. Agentning sifati bilimlar bazasi va chegaralarning aniqligiga bog'liq.",
        steps: [
            {
                t: "Savollarni yig'ish",
                time: "3–7 kun",
                d: "Telegram va Instagram yozishmalari, qo'ng'iroq yozuvlari va menejerlar tajribasini ko'rib chiqamiz. Mijoz haqiqatda nima so'rashini bilmasdan agent qurib bo'lmaydi.",
            },
            {
                t: "Bilimlar bazasi va chegaralar",
                time: "1–2 hafta",
                d: "Narx, shart va kafolat tizimlashtiriladi. Shu bilan birga agent nima qila olmasligi yoziladi: chegirma bermaydi, pul qaytarmaydi, shartnoma o'zgartirmaydi.",
            },
            {
                t: "Agentni qurish",
                time: "2–5 hafta",
                d: "Model sozlanadi, RAG indeksi yig'iladi, harakatlar (qoldiq, buyurtma, to'lov) ulanadi. Har hafta demo — o'zgarishlar jarayon davomida kiritiladi.",
            },
            {
                t: "Sinov",
                time: "1–2 hafta",
                d: "Kamida 150 ta real savol bilan sinaymiz, noto'g'ri javoblarni yozib boramiz va menejerga uzatish chegarasini sozlaymiz. Bu bosqichni qisqartirish tavsiya etilmaydi.",
            },
            {
                t: "Ishga tushirish va sozlash",
                time: "davomiy",
                d: "Agent kanallarga ulanadi. Birinchi oyda suhbatlar har hafta tahlil qilinadi, bilimlar bazasi to'ldiriladi va javob sifati bosqichma-bosqich ko'tariladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan yechimlar",
        sub: "Har bir loyihada stsenariy, integratsiya va texnik qism biz tomonimizdan tayyorlangan.",
        cta: "Barcha loyihalar",
        slugs: ["myyurist", "rememberme", "neurotagline", "imtihan"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "AI Agent bo'yicha eng ko'p so'raladigan savollar va halol javoblar.",
        items: [
            {
                q: "AI Agent yaratish qancha turadi?",
                a: "Start tarifi 15 000 000 so'mdan boshlanadi — bu bitta kanalda ishlaydigan, bilimlar bazasidan javob beradigan va ariza yig'adigan agent. Buyurtma rasmiylashtiradigan, CRM'ga ulangan Biznes tarifi 38 000 000 so'mdan. Bu bir martalik to'lov. Model API'si uchun oylik xarajat alohida — suhbatlar soniga qarab 250 000 so'mdan 3 500 000 so'mgacha.",
            },
            {
                q: "Agent chatbotdan nimasi bilan farq qiladi?",
                a: "Chatbot savolga matn bilan javob beradi. Agent esa suhbat davomida real harakat bajaradi: ombordan qoldiqni tekshiradi, summani hisoblaydi, buyurtma yaratadi, to'lov havolasini yuboradi va navbatga yozadi. Ya'ni mijoz javob olish bilan cheklanmay, ishni to'liq yakunlay oladi — saytga o'tish yoki menejerni kutish shart emas.",
            },
            {
                q: "Agent noto'g'ri javob berib qo'ymaydimi?",
                a: "Bunday xavf bor va biz uni yashirmaymiz. Til modellari gallyutsinatsiyaga moyil. Xavfni kamaytirish uchun agent faqat sizning bilimlar bazangiz doirasida javob beradi, narx va qoldiq kabi aniq ma'lumotni har safar bazadan oladi, mos ma'lumot topilmasa esa menejerga uzatadi. Sinov bosqichida kamida 150 ta savol tekshiriladi.",
            },
            {
                q: "Agent o'zbek tilini tushunadimi?",
                a: "Ha. Claude va GPT modellari o'zbek tilini yaxshi tushunadi — lotin va kirill yozuvida, hamda aralash o'zbekcha-ruscha matnda ham. Javob tili mijoz yozgan tilga qarab avtomatik tanlanadi. Ovozli xabarlar Whisper orqali matnga o'giriladi, ammo o'zbekcha ovozda aniqlik rus tiliga nisbatan biroz pastroq.",
            },
            {
                q: "Agent qaysi kanallarda ishlaydi?",
                a: "Telegram Bot API orqali Telegram'da, WhatsApp Business API orqali WhatsApp'da, shuningdek Instagram Direct va saytdagi vidjetda. Bitta agent barcha kanalda bir xil bilimlar bazasidan ishlaydi — har biri uchun alohida bot qurish shart emas. Start tarifida bitta kanal, Biznes tarifida hammasi ulanadi.",
            },
            {
                q: "Agent menejerni almashtiradimi?",
                a: "Yo'q. U takroriy savollarni oladi va murojaatni yo'qotmaydi, lekin qaror qabul qilish odamda qoladi. Chegirma berish, shikoyatni hal qilish, pul qaytarish va nostandart kelishuvlar menejerga uzatiladi. Amalda xodim soni odatda o'zgarmaydi — bir xil jamoa ko'proq murojaatni ko'taradi va har bir suhbatga ko'proq vaqt ajrata oladi, chunki oddiy savollar allaqachon yopilgan bo'ladi.",
            },
            {
                q: "Qachon AI Agent kerak emas?",
                a: "Agar kuniga 10–15 tadan kam murojaat kelsa, agent iqtisodiy jihatdan o'zini oqlamaydi — menejer bemalol ulguradi. Savollar juda tor va bir xil bo'lsa, oddiy tugmali bot arzonroq. Shuningdek, har bir murojaat yuridik yoki tibbiy javobgarlik talab qilsa, AI'ga suhbatni topshirish tavsiya etilmaydi.",
            },
            {
                q: "Agent qancha vaqtda tayyor bo'ladi?",
                a: "Start tarifi 3–4 haftada, Biznes tarifi 6–9 haftada ishga tushadi. Muddat sizdan materiallar qanchalik tez kelishiga bog'liq: narxlar ro'yxati, kafolat shartlari, yetkazib berish qoidalari va CRM'ga kirish huquqi. Integratsiya murakkab bo'lsa yoki 1C eski versiyada ishlayotgan bo'lsa, muddat 2–3 haftaga uzayishi mumkin. Buni boshida ochiq ogohlantiramiz.",
            },
            {
                q: "Suhbatlar va mijoz ma'lumotlari qayerda saqlanadi?",
                a: "Suhbatlar sizning serveringizda yoki siz tanlagan bulutda saqlanadi, biz nusxa olmaymiz. Modelga faqat joriy savolga tegishli kontekst yuboriladi. Anthropic va OpenAI biznes shartlariga ko'ra API orqali yuborilgan ma'lumot model o'qitishga ishlatilmaydi. Yopiq kontur kerak bo'lsa, model o'z serveringizda ishlatiladi va hech qanday ma'lumot kompaniyadan tashqariga chiqmaydi.",
            },
            {
                q: "Bilimlar bazasini o'zim yangilay olamanmi?",
                a: "Ha. Admin panel barcha tariflarga kiradi: matn, narx va savol-javoblarni o'zingiz tahrirlaysiz, o'zgarish bir necha daqiqada kuchga kiradi. Biznes tarifida PDF yoki Excel faylni yuklab, bazani ommaviy yangilash mumkin. Noto'g'ri javoblarni belgilab qo'yasiz — shu ro'yxat keyingi sozlash uchun asos bo'ladi.",
            },
        ],
    },

    cta: {
        h: "Mijozlaringiz eng ko'p nimani so'raydi?",
        p: "Bepul konsultatsiyada yozishmalaringizni ko'rib chiqamiz, agent qaysi savollarni yopa olishini va qaysilarini odam hal qilishi kerakligini aytamiz. Keyin aniq narx va muddat beramiz. Majburiyat yo'q — +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "+998 90 954 12 62",
    },

    images: [
        {
            src: "/assets/img/projects/myyurist.webp",
            alt: "MyYurist loyihasi — yuridik savollarga javob beradigan AI agent interfeysi",
            caption: "MyYurist — yuridik savollar bo'yicha maslahat beradigan AI yechim.",
        },
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Telegram bot loyihasi — mijozlar bilan avtomatik muloqot va buyurtma qabul qilish",
            caption: "Telegram kanalidagi agent: savolga javob beradi va buyurtmani rasmiylashtiradi.",
        },
        {
            src: "/assets/img/services/ai-agent-suhbat.webp",
            alt: "AI Agent suhbati — mijoz savoli, qoldiq tekshiruvi va buyurtma rasmiylashtirish",
            caption: "Suhbat namunasi: agent qoldiqni tekshiradi, narxni hisoblaydi va to'lov havolasini yuboradi.",
            prompt:
                "Mobile messenger chat mockup on a dark background showing an AI assistant conversation: customer asks about product availability, assistant replies with stock status, price calculation and a payment link button. Clean modern UI, green and blue accents, generic product, no real brand names.",
        },
        {
            src: "/assets/img/services/ai-agent-arxitektura.webp",
            alt: "AI Agent arxitekturasi — kanallar, til modeli, vektor baza va CRM integratsiyasi",
            caption: "Arxitektura: Telegram va WhatsApp kanallari, RAG bilimlar bazasi va CRM bir tizimda.",
            prompt:
                "Flat technical architecture diagram on dark background: messaging channels (Telegram, WhatsApp, website widget) connecting to an AI agent core, which links to a vector knowledge base, a CRM system and a human handover queue. Minimal style, blue and teal accents, English labels, no people.",
        },
    ],

    related: ["sun-iy-intellekt", "ai-integratsiya", "telegram-bot", "crm-tizimlar"],
};

const ru = {
    meta: {
        title: "AI-агент для бизнеса — общение с клиентами 24/7",
        description:
            "AI-агент общается с клиентами 24/7: отвечает на вопросы, оформляет заказы и записывает их в CRM. Telegram, WhatsApp и сайт. Цена от 15 млн сум. Innobek, Ташкент.",
        keywords: [
            "AI-агент",
            "разработка AI-агента",
            "агент на искусственном интеллекте",
            "обслуживание клиентов 24/7",
            "Telegram AI бот",
            "WhatsApp бот",
            "бот для приёма заказов",
            "стоимость AI-агента",
            "Claude API",
            "база знаний RAG",
        ],
    },

    hero: {
        eyebrow: "Искусственный интеллект / AI-агент",
        h1: "AI-агент, который общается с вашими клиентами 24/7",
        lead:
            "Если ответить на вечернее сообщение только утром, клиент уже купит в другом месте. AI-агент отвечает сразу: называет цену, оформляет заказ и передаёт разговор менеджеру там, где нужен человек.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Telegram, WhatsApp, Instagram и сайт",
            "Отвечает на узбекском и русском",
            "Понимает голосовые сообщения",
            "Сам записывает заказ в CRM",
            "Не знает — не выдумывает, а передаёт человеку",
        ],
    },

    intro: {
        h: "Что такое AI-агент и чем он отличается от обычного чат-бота",
        p: [
            "Обычный бот работает по кнопкам: клиент нажимает, бот выдаёт готовый текст. Стоит вопросу выйти за рамки списка — диалог обрывается. Чат-бот на шаг дальше: он понимает смысл и отвечает текстом. AI-агент идёт ещё дальше — он не ограничивается ответом, а выполняет действия.",
            "Разница в возможности, которую называют tool use. Агенту выдаются конкретные инструменты: проверить остаток на складе, рассчитать цену, создать заказ, выдать ссылку на оплату, записать на приём, узнать статус доставки. Когда клиент пишет «есть 42-й размер, доставите сегодня?», агент обращается к базе и отвечает по факту, а не по предположению.",
            "Знания агента строятся через RAG. Ваш прайс, условия услуг, правила гарантии и частые вопросы попадают в векторную базу (pgvector или Qdrant). При каждом вопросе система находит подходящие фрагменты и передаёт их модели — поэтому агент не берёт случайную информацию из интернета.",
            "Важное ограничение: агент умеет не всё, и мы намеренно не настраиваем его на всё. Возврат денег, скидка, разбор жалобы или изменение условий договора остаются за человеком. Агент распознаёт такие ситуации и передаёт диалог менеджеру вместе со всем контекстом переписки.",
            "Техническая основа: Claude API или OpenAI API, интеграции через REST API, расшифровка голосовых через Whisper, каналы через Telegram Bot API и WhatsApp Business API. Все диалоги сохраняются — потом мы разбираем их и повышаем качество ответов.",
        ],
    },

    definition: {
        term: "Что такое AI-агент?",
        text:
            "AI-агент — программа на искусственном интеллекте, которая общается с клиентом на естественном языке и по ходу диалога выполняет реальные действия: проверяет остатки, оформляет заказ, записывает на приём.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные дополнения — всё есть даже в базовом тарифе.",
        items: [
            "Сбор и анализ клиентских вопросов (переписки, звонки)",
            "Составление базы знаний: цены, условия, гарантия, FAQ",
            "Согласование характера агента и тона общения",
            "Настройка векторной базы (pgvector или Qdrant) и индексация",
            "Подключение и настройка Claude API или OpenAI API",
            "Определение и ограничение списка действий агента",
            "Правила и пороги передачи разговора менеджеру",
            "Тестирование не менее чем на 150 реальных вопросах",
            "Установка в канал: Telegram, виджет на сайте или WhatsApp",
            "Админ-панель: обновление базы знаний и просмотр диалогов",
            "Инструкция для сотрудников и обучение режиму оператора",
            "Реальный замер и прогноз месячного расхода на API",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем нужен",
        h: "Что AI-агент даёт бизнесу",
        sub: "Агент не заменяет менеджера. Он забирает рутину и не даёт обращениям теряться.",
        items: [
            {
                t: "Ночные обращения не теряются",
                d: "В онлайн-продажах заметная часть обращений приходит вечером и в выходные. Часть клиентов, прождавших до утра, уже не возвращается. Агент отвечает в любое время за 10–20 секунд и как минимум собирает номер телефона.",
            },
            {
                t: "Освобождается время менеджера",
                d: "«Сколько стоит?», «Во сколько работаете?», «Доставка есть?» — на такие типовые вопросы приходится 50–70% обращений. Агент закрывает их, а менеджер занимается крупными заказами и сложными переговорами.",
            },
            {
                t: "Заказ оформляется прямо в диалоге",
                d: "Агент показывает товар из каталога, проверяет остаток, считает сумму и присылает ссылку на оплату. Отправлять клиента на сайт не нужно — именно на этих переходах теряется конверсия. Данные заказа сразу попадают в CRM, менеджер видит готовую карточку.",
            },
            {
                t: "Сотни диалогов одновременно",
                d: "Во время акции или рекламной кампании поток вырастает в несколько раз. Человек ставит клиентов в очередь, агент работает параллельно — время ожидания не меняется.",
            },
            {
                t: "Одинаковое качество каждого ответа",
                d: "Агент не устаёт, не бывает в плохом настроении и не забывает условие гарантии. Вместо двухмесячного обучения нового сотрудника вы один раз правильно собираете базу знаний. Поменялась цена — правите в одном месте, и это сразу действует во всех каналах.",
            },
            {
                t: "Видно, о чём спрашивают клиенты",
                d: "Все диалоги сохраняются и классифицируются. Через месяц вы точно знаете, какой вопрос задают чаще всего и на каком шаге клиент уходит — это готовые данные для правки сайта и цен.",
            },
            {
                t: "Можно начать с малого",
                d: "Начинаем с одного канала и одной задачи. За три-четыре недели агент запускается, и вы видите реальный результат. Расширение — потом, когда работа подтверждена цифрами.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Какому бизнесу нужен AI-агент",
        sub: "Сферы, где приходит больше 30 обращений в день и скорость ответа влияет на продажи.",
        items: [
            {
                t: "Интернет-магазины и маркетплейсы",
                d: "Наличие товара, размеры, сроки доставки и статус заказа — агент проверяет по базе и отвечает фактами.",
            },
            {
                t: "Клиники и медицинские центры",
                d: "Цены на услуги, расписание врачей и запись на приём. Постановка диагноза на агента не перекладывается — это жёсткая граница.",
            },
            {
                t: "Учебные центры и курсы",
                d: "Программа, цена, расписание, пробное занятие и запись. Цикл сделки короткий, поэтому быстрый ответ прямо влияет на конверсию.",
            },
            {
                t: "Рестораны и доставка",
                d: "Подсказки по меню, приём заказа, уточнение адреса и сообщение времени готовности.",
            },
            {
                t: "Недвижимость и строительство",
                d: "Объекты, цены, условия оплаты и запись на просмотр. Агент квалифицирует клиента, менеджер получает готовое обращение.",
            },
            {
                t: "Сервисные компании",
                d: "Вызов мастера, уточнение района и сроков, предварительный расчёт цены и полное оформление заявки.",
            },
            {
                t: "Туризм и перевозки",
                d: "Туры, наличие мест на дату, требования к документам и бронирование — агент отвечает, сверившись с календарём.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость AI-агента — три тарифа",
        sub: "Разработка оплачивается один раз. Месячный расход на API модели считается отдельно.",
        note:
            "Цены указаны на 2026 год, итоговая смета подтверждается после бесплатной консультации. Месячный расход на API зависит от числа диалогов: при 50–150 диалогах в день это примерно 250 000 – 900 000 сум, при 300–800 — от 1 000 000 до 3 500 000 сум. Сумма платится напрямую провайдеру (Anthropic или OpenAI), мы не добавляем процент. Для WhatsApp Business API есть отдельная плата Meta за сообщения — точный расчёт покажем на консультации.",
        tiers: [
            {
                name: "Start",
                tagline: "Агент, отвечающий в одном канале",
                price: "15 000 000",
                priceNote: "сум",
                term: "3–4 недели",
                best: "Закрыть типовые вопросы и не терять обращения",
                features: [
                    "Один канал: Telegram или виджет на сайте",
                    "База знаний на RAG, до 300 страниц материалов",
                    "Подключение Claude API или OpenAI API",
                    "Векторная база на pgvector",
                    "Ответы на узбекском и русском",
                    "Сбор заявок: имя, телефон, запрос",
                    "Уведомления менеджеру в Telegram",
                    "Передача человеку при низкой уверенности",
                    "История диалогов и базовая статистика",
                    "Админ-панель для обновления базы знаний",
                    "3 месяца технической поддержки",
                ],
            },
            {
                name: "Бизнес",
                tagline: "Агент с действиями, встроенный в продажи",
                price: "38 000 000",
                priceNote: "сум",
                term: "6–9 недель",
                best: "Оформлять заказ прямо в диалоге и работать с CRM",
                featured: true,
                features: [
                    "Всё из тарифа Start",
                    "Много каналов: Telegram, WhatsApp, Instagram Direct и сайт",
                    "Tool use: проверка остатков, расчёт цены, создание заказа",
                    "Двусторонняя интеграция с CRM или 1С",
                    "Ссылка на оплату и отслеживание статуса заказа",
                    "Модуль записи или бронирования",
                    "Понимание голосовых сообщений через Whisper",
                    "Режим оператора — менеджер может вмешаться в диалог",
                    "Расширенная аналитика: типы вопросов, конверсия, причины передачи",
                    "Загрузка базы знаний из файлов PDF и Excel",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Закрытый контур и высокая нагрузка",
                price: "По договору",
                priceNote: "",
                term: "от 3 месяцев",
                best: "Организациям с внутренними системами и требованиями к конфиденциальности",
                features: [
                    "Открытая модель на вашем сервере (Llama, Qwen)",
                    "Подключение к ERP, складу и базам документов",
                    "Отдельные роли и базы знаний по отделам",
                    "Голосовой агент, принимающий звонки",
                    "Журнал аудита и маскирование персональных данных",
                    "Нагрузочное тестирование и SLA",
                    "Постоянный контроль качества и донастройка модели",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как создаётся AI-агент",
        sub: "Пять этапов. Качество агента определяется базой знаний и чёткостью его границ.",
        steps: [
            {
                t: "Сбор вопросов",
                time: "3–7 дней",
                d: "Разбираем переписки в Telegram и Instagram, записи звонков и опыт менеджеров. Если не знать, о чём клиенты спрашивают на самом деле, собрать агента невозможно.",
            },
            {
                t: "База знаний и границы",
                time: "1–2 недели",
                d: "Систематизируем цены, условия и гарантию. Одновременно фиксируем, чего агент не делает: не даёт скидок, не возвращает деньги, не меняет условия договора.",
            },
            {
                t: "Сборка агента",
                time: "2–5 недель",
                d: "Настраиваем модель, собираем RAG-индекс, подключаем действия (остатки, заказ, оплата). Демо показываем еженедельно, правки вносим по ходу работы.",
            },
            {
                t: "Тестирование",
                time: "1–2 недели",
                d: "Проверяем минимум на 150 реальных вопросах, фиксируем неверные ответы и настраиваем порог передачи менеджеру. Сокращать этот этап мы не рекомендуем.",
            },
            {
                t: "Запуск и донастройка",
                time: "постоянно",
                d: "Агент подключается к каналам. В первый месяц разбираем диалоги еженедельно, дополняем базу знаний и постепенно повышаем качество ответов.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Решения, которые мы построили",
        sub: "В каждом проекте сценарии, интеграции и разработка сделаны нашей командой.",
        cta: "Все проекты",
        slugs: ["myyurist", "rememberme", "neurotagline", "imtihan"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Честные ответы на самые частые вопросы об AI-агентах.",
        items: [
            {
                q: "Сколько стоит разработка AI-агента?",
                a: "Тариф Start начинается от 15 000 000 сум — это агент в одном канале, который отвечает по базе знаний и собирает заявки. Тариф «Бизнес» с оформлением заказов и интеграцией CRM — от 38 000 000 сум. Это разовая оплата. Расход на API модели считается отдельно: от 250 000 до 3 500 000 сум в месяц в зависимости от числа диалогов.",
            },
            {
                q: "Чем агент отличается от чат-бота?",
                a: "Чат-бот отвечает текстом. Агент по ходу диалога выполняет реальные действия: проверяет остаток на складе, считает сумму, создаёт заказ, присылает ссылку на оплату и записывает на приём. То есть клиент не просто получает ответ, а доводит дело до конца — без перехода на сайт и ожидания менеджера.",
            },
            {
                q: "Не будет ли агент отвечать неправильно?",
                a: "Такой риск есть, и мы его не скрываем. Языковые модели склонны к галлюцинациям. Чтобы снизить риск, агент отвечает только в рамках вашей базы знаний, точные данные вроде цены и остатка каждый раз берёт из базы, а при отсутствии подходящей информации передаёт разговор менеджеру. На тестах проверяем минимум 150 вопросов.",
            },
            {
                q: "Понимает ли агент узбекский язык?",
                a: "Да. Модели Claude и GPT хорошо понимают узбекский — и на латинице, и на кириллице, и в смешанном узбекско-русском тексте. Язык ответа выбирается автоматически по языку клиента. Голосовые расшифровываются через Whisper, но точность распознавания узбекской речи немного ниже, чем русской.",
            },
            {
                q: "В каких каналах работает агент?",
                a: "В Telegram через Telegram Bot API, в WhatsApp через WhatsApp Business API, а также в Instagram Direct и в виджете на сайте. Один агент работает во всех каналах на одной базе знаний — отдельного бота под каждый канал делать не нужно. В тарифе Start один канал, в «Бизнесе» подключаются все.",
            },
            {
                q: "Заменит ли агент менеджера?",
                a: "Нет. Он забирает типовые вопросы и не даёт обращениям теряться, но решения остаются за человеком. Скидки, разбор жалоб, возвраты и нестандартные договорённости передаются менеджеру. На практике штат обычно не меняется — просто та же команда справляется с большим потоком и уделяет больше времени каждой сделке, потому что простые вопросы уже закрыты.",
            },
            {
                q: "Когда AI-агент не нужен?",
                a: "Если в день приходит менее 10–15 обращений, агент экономически не окупается: менеджер справляется сам. Если вопросы очень узкие и однотипные, дешевле обойдётся обычный кнопочный бот. Также не стоит отдавать диалог ИИ там, где каждый ответ означает юридическую или медицинскую ответственность. В таких случаях мы прямо советуем не тратить бюджет.",
            },
            {
                q: "За сколько времени будет готов агент?",
                a: "Тариф Start запускается за 3–4 недели, «Бизнес» — за 6–9 недель. Срок зависит от того, как быстро вы предоставите материалы: прайс, условия гарантии, правила доставки и доступ к CRM. При сложной интеграции или старой версии 1С срок может вырасти на 2–3 недели. Мы предупреждаем об этом сразу.",
            },
            {
                q: "Где хранятся диалоги и данные клиентов?",
                a: "Диалоги хранятся на вашем сервере или в выбранном вами облаке, копий мы себе не оставляем. Модели передаётся только контекст текущего вопроса. По бизнес-условиям Anthropic и OpenAI данные из API не используются для обучения моделей. Если нужен закрытый контур, модель ставится на ваш сервер.",
            },
            {
                q: "Смогу ли я сам обновлять базу знаний?",
                a: "Да. Админ-панель входит во все тарифы: тексты, цены и вопросы-ответы вы правите сами, изменения вступают в силу за считаные минуты. В тарифе «Бизнес» базу можно обновлять массово, загрузив PDF или Excel. Неверные ответы вы помечаете — по этому списку проводится следующая донастройка.",
            },
        ],
    },

    cta: {
        h: "О чём чаще всего спрашивают ваши клиенты?",
        p: "На бесплатной консультации разберём вашу переписку, скажем, какие вопросы агент сможет закрыть, а какие должен решать человек. Затем назовём точную цену и срок. Без обязательств — +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "+998 90 954 12 62",
    },

    images: [
        {
            src: "/assets/img/projects/myyurist.webp",
            alt: "Проект MyYurist — интерфейс AI-агента, отвечающего на юридические вопросы",
            caption: "MyYurist — ИИ-решение, которое консультирует по юридическим вопросам.",
        },
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Проект Telegram-бота — автоматическое общение с клиентами и приём заказов",
            caption: "Агент в Telegram: отвечает на вопросы и оформляет заказ в диалоге.",
        },
        {
            src: "/assets/img/services/ai-agent-suhbat.webp",
            alt: "Диалог AI-агента — вопрос клиента, проверка остатка и оформление заказа",
            caption: "Пример диалога: агент проверяет остаток, считает цену и присылает ссылку на оплату.",
            prompt:
                "Mobile messenger chat mockup on a dark background showing an AI assistant conversation: customer asks about product availability, assistant replies with stock status, price calculation and a payment link button. Clean modern UI, green and blue accents, generic product, no real brand names.",
        },
        {
            src: "/assets/img/services/ai-agent-arxitektura.webp",
            alt: "Архитектура AI-агента — каналы, языковая модель, векторная база и CRM",
            caption: "Архитектура: каналы Telegram и WhatsApp, база знаний на RAG и CRM в одной системе.",
            prompt:
                "Flat technical architecture diagram on dark background: messaging channels (Telegram, WhatsApp, website widget) connecting to an AI agent core, which links to a vector knowledge base, a CRM system and a human handover queue. Minimal style, blue and teal accents, English labels, no people.",
        },
    ],

    related: ["sun-iy-intellekt", "ai-integratsiya", "telegram-bot", "crm-tizimlar"],
};

const content = { uz, ru };

export default content;
